<template>
  <b-modal ref="checked-baggage-modal-ref" hide-footer title="Checked Baggage Information">
    <div v-if="baggage">
      <span class="baggage-info"
        >Your checked baggage allowance is listed below per person. Please scroll down to see the
        allowance for all flights on your itinerary - this may differ between flights. Please note that baggage allowances do not show for any flights not yet booked. It is displayed in weight, dimensions and number of permitted bags where applicable.
      </span>
      <br />
      <br />
      <span class="baggage-info"
        >Please also note that some transfers and/or tours have luggage restrictions on them such as seaplanes and overland adventures. Please see your itinerary for specific details and take this into consideration when packing.
      </span>
      <br />
      <br />
      <strong
        >If you require a higher luggage allowance, you will need to arrange this directly with the
        airline by paying for more. This can be done on their website via their manage booking link,
        which you can access using your surname and Airline Reference from your itinerary.</strong
      >
      <br />
      <div v-if="flightsArr.length > 0" class="d-flex expand-collapse-container">
        <button class="vtd-btn mt-3" @click="toggleExpandAll">
          {{ buttonText }}
        </button>
      </div>

      <div v-if="flightsArr.length === 0">
        <p class="mt-3">No baggage information found for your booking</p>
      </div>
      <div v-for="(flight, index) in flightsArr" :key="index">
        <CheckedBaggageDay
          :id="flight.flightno"
          :flight="flight"
          :flight-no="flight.flightno"
          :itinerary="matchingItinerary(flight.flightno, flight.galLocator, flight.deptime)"
          :baggage="matchingBaggage(flight.flightno, flight.galLocator)"
          :dropdown-prop="checkDates(index)"
          :expand-all-prop="expandAll" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckedBaggageDay from './day'

export default {
  components: {
    CheckedBaggageDay,
  },
  props: {
    itineraryArr: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      displaySelected: 'ALL',
      expandAll: false,
      flightNo: '',
    }
  },
  computed: {
    ...mapGetters({
      baggage: 'baggage/getBaggage',
    }),
    buttonText() {
      return this.expandAll ? 'Close All' : 'Expand All'
    },
    flightsArr() {
      let arr = []
      let dupeCheckedObj = {}
      this.baggage.checked.forEach((item) => {
        let { galLocator } = item
        item.flights.forEach((flight) => {
          const matchingItinItem = this.matchingItinerary(
            flight.flightno,
            galLocator,
            flight.deptime
          )
          flight.depdate = matchingItinItem.depdate
          flight.galLocator = galLocator
          if (
            !dupeCheckedObj[`${flight.flightno}`] ||
            (dupeCheckedObj[`${flight.flightno}`] &&
              (dupeCheckedObj[`${flight.flightno}`].deptime !== flight.deptime ||
                dupeCheckedObj[`${flight.flightno}`].vendorloc !== matchingItinItem.vendorloc))
          ) {
            dupeCheckedObj[`${flight.flightno}`] = { deptime: '', vendorloc: '' }
            dupeCheckedObj[`${flight.flightno}`].deptime = flight.deptime
            dupeCheckedObj[`${flight.flightno}`].vendorloc = matchingItinItem.vendorloc
            arr.push(flight)
          }
        })
      })
      // sort the resulting array by depdate
      arr.sort((a, b) => {
        const dateA = new Date(a.depdate)
        const dateB = new Date(b.depdate)
        // if two dates are the same, compare flights by deptime
        if (dateA.getTime() === dateB.getTime()) {
          const timeA = new Date(a.deptime)
          const timeB = new Date(b.deptime)
          return timeA.getTime() - timeB.getTime()
        } else {
          // otherwise, compare by date
          return dateA.getTime() - dateB.getTime()
        }
      })
      return arr
    },
    baggageArr() {
      const flatBaggageArr = []
      this.baggage.checked.forEach((item) => {
        if (item.baggageItem) {
          let modifiedBaggageItem = Object.assign(item.baggageItem, {
            flights: item.flights,
          })
          modifiedBaggageItem.galLocator = item.galLocator
          flatBaggageArr.push(modifiedBaggageItem)
        } else {
          flatBaggageArr.push({
            flights: [],
            pieces: 'No checked baggage',
          })
        }
      })
      return flatBaggageArr
    },
  },
  mounted() {
    this.$nextTick(function () {
      if (this.$refs.itineraryItemRef && this.$refs.itineraryItemRef[0]) {
        this.$refs.itineraryItemRef[0].toggleExpand()
      }
    })
    this.$refs['checked-baggage-modal-ref'].$on('hide', this.onHide)
  },
  methods: {
    showModal(flightNo) {
      if (flightNo) this.flightNo = flightNo
      this.$refs['checked-baggage-modal-ref'].show()
      if (flightNo) {
        setTimeout(() => {
          document.getElementById(flightNo).scrollIntoView({ block: 'start', behavior: 'smooth' })
        }, 1200)
      }
    },
    onHide() {
      setTimeout(() => {
        this.expandAll = false
      }, 400)
    },
    checkItineraryDay(types, type) {
      if (type === 'ALL') {
        return true
      } else {
        if (types.indexOf(type) > -1) {
          return true
        }
      }
    },
    matchingItinerary(flightNo, galLocator, departureTime) {
      // adding galLocator as a 2nd parameter will remove bugs when there are multiple tickets on the same flight
      const matchingItems = this.itineraryArr.filter((item) => {
        const _values = Object.values(item)
        return _values.includes(galLocator) && _values.includes(flightNo)
      })
      if (matchingItems.length === 1) {
        return matchingItems[0]
      } else if (!matchingItems.length) {
        return {}
      }
      // else, more than 1 flight with the same flight number and gal locator (e.g. BA2159 LGW-UVF-GND. The flight touches down in St Lucia (UVF) and then continues to Grenada. Same flight number.)
      // so, match by departure time as well
      const correctFlight = matchingItems.find((item) => {
        let _formattedDepTime = item.deptime.replace(':', '').trim()
        return _formattedDepTime === departureTime.trim()
      })
      return correctFlight ? correctFlight : matchingItems[0]
    },
    matchingBaggage(flightNo, galLocator) {
      // adding galLocator as a 2nd parameter will remove bugs when there are multiple tickets on the same flight
      const matchingBaggageItem = this.baggage.checked.find((item) => {
        return Object.values(item.flights).find((flight) => {
          const _values = Object.values(flight)

          return _values.includes(galLocator) && _values.includes(flightNo)
        })
      })
      return matchingBaggageItem ? matchingBaggageItem.baggageItem : {}
    },
    checkDates(index) {
      const today = new Date().getTime()
      const depDates = this.itineraryArr.map((item) => {
        return Date.parse(item.depdate)
      })
      // if holiday has not yet begun, open first dropdown
      if (today < depDates[0] && index === 0) {
        return true
      } else if (today >= depDates[0]) {
        // if holiday has begun, open dropdowns programatically
        let count = 0
        for (let i = 0; i < depDates.length; i++) {
          if (today > depDates[i]) {
            count++
          }
        }
        if (count === index) {
          return true
        }
      } else {
        return false
      }
    },
    toggleExpandAll() {
      this.expandAll = !this.expandAll
    },
  },
}
</script>

<style>
@import './styles.scss';
</style>
